module.exports = __webpack_public_path__ + "54dafc9ae3a5c6b94dd55eadd4005e10.svg";